import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TtcBadgeModule } from '@libs/src/ttc-badge/ttc-badge.module';

import { FeedItemTitleComponent } from './feed-item-title.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    RouterModule,
    TtcBadgeModule,
  ],
  declarations: [FeedItemTitleComponent],
  exports: [FeedItemTitleComponent],
})
export class FeedItemTitleModule {}
